import { CommonUtilities } from '../../../commonUtils';

export default class systemListingService {

    static getSalesAnalysissales(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/sales?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getSalesAnalysismechanical(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/mechanical?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getSalesAnalysispublishing(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/publishing?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getSalesAnalysiscosts(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/costs?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getSalesAnalysisadvances(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/advances?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getSalesAnalysislicensing(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/licensing?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getAllFormatCodeByParentGroup(data: any) {
        var url = 'release/getAllFormatCodeByParentGroup?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static FormatReleaseListing(data: any) {
        var url = 'release/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static MechanicalRateCount(data: any) {
        var url = 'contracts/mechRate/count?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static MechanicalRateListing(data: any) {
        var url = 'contracts/mechRate/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getAllClientZones(param: any) {
        var url = 'contracts/zones/getAllClientZones?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static systemFormatsList() {
        var url = 'contracts/systemFormats?isPartFormatListed=true';
        return CommonUtilities.getData(url);
    }

    static classList(data: any) {
        var url = 'salesAnalysis/classlist/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }
    static territoryList(data: any) {
        var url = 'systemListing/territory/territoryList?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static accountSubproviderList(data: any) {
        var url = 'systemListing/accountSubprovider/ASPlist?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static contractStatusList(data: any) {
        var url = 'contracts/contractStatus/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }


    /* ******************SAVE**************************** */

    static saveContractStatus(data: any) {
        var url = 'contracts/contractStatus/save/'
        return CommonUtilities.postData(url, data);
    }

    static saveProjectStatus(data: any) {
        var url = 'common/projectStatus/save/'
        return CommonUtilities.postData(url, data);
    }

    static saveStatusAccount(data: any) {
        var url = 'common/statusAccount/save/'
        return CommonUtilities.postData(url, data);
    }

    static saveStatusAccountExt(data: any) {
        var url = 'common/statusAccountExt/save/'
        return CommonUtilities.postData(url, data);
    }

    static saveStatusStatement(data: any) {
        var url = 'common/statusStatement/save/'
        return CommonUtilities.postData(url, data);
    }

    static saveFormat(data: any) {
        var url = 'release/saveFormat/'
        return CommonUtilities.postData(url, data);
    }

    static saveFormatRelease(data: any) {
        var url = 'release/save/'
        return CommonUtilities.postData(url, data);
    }

    static saveStatusPayee(data: any) {
        var url = 'common/statusPayee/save/'
        return CommonUtilities.postData(url, data);
    }

    static saveStatusProduct(data: any) {
        var url = 'common/statusProduct/save/'
        return CommonUtilities.postData(url, data);
    }

    static saveStatusProductExt(data: any) {
        var url = 'common/statusProductExt/save/'
        return CommonUtilities.postData(url, data);
    }

    static saveSalesAnalysissales(data: any) {
        var url = '/salesAnalysis/saveSalesAnalysis/'
        return CommonUtilities.postData(url, data);
    }

    static saveAccountSubprovider(data: any) {
        var url = 'systemListing/accountSubprovider/save'
        return CommonUtilities.postData(url, data);
    }


    /* ********************************************** */

    static projectStatusList(data: any) {
        var url = 'contracts/projectStatus/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusAccountList(data: any) {
        var url = 'common/statusAccount/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusAccountExtList(data: any) {
        var url = 'common/statusAccountExt/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusPayeeList(data: any) {
        var url = 'common/statusPayee/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusStatementList(data: any) {
        var url = 'common/statusStatement/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusProductList(data: any) {
        var url = 'common/statusProduct/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusProductExtList(data: any) {
        var url = 'common/statusProductExt/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    /* ********************* System Listing ********************* */
    static deleteAnalysisCode(data: any) {
        var url = 'salesAnalysis/deleteSalesAnalysis/'
        return CommonUtilities.postData(url, data);
    }

    static deleteFormatCodes = function (format: any) {
        var url = '/release/deleteFormat/' + format.formatId;
        return CommonUtilities.postData(url, {});
    };

    static deleteFormatRelease = function (format: any) {
        var url = '/release/delete/' + format.releaseId;
        return CommonUtilities.deleteData(url);
    };

    static deleteMechRate = function (MechRate: any) {
        var url = 'contracts/mechRate/' + MechRate;
        return CommonUtilities.deleteData(url);
    };

    static deleteClassList = function (classlistId: any) {
        var url = 'salesAnalysis/classlist/delete/' + classlistId;
        return CommonUtilities.deleteData(url);
    };

    static deleteTerritoryCode = function (territory: any) {
        var url = 'systemListing/territory/delete/' + territory.territoryCode;
        return CommonUtilities.deleteData(url);
    };

    static deleteAccountCode = function (account: any) {
        var url = 'systemListing/accountSubprovider/delete/' + account.transMappingASId;
        return CommonUtilities.deleteData(url);
    };

    static deleteStatusAccount = function (statusAccount: any) {
        var url = 'common/statusAccount/delete/' + statusAccount.acctStatusID;
        return CommonUtilities.deleteData(url);
    };

    static deletestatusAccountExt = function (statusAccountExt: any) {
        var url = 'common/statusAccount/delete/' + statusAccountExt.acctStatusExtID;
        return CommonUtilities.deleteData(url);
    };

    static deleteclasslist = function (classlist: any) {
        var url = 'salesAnalysis/classlist/delete/' + classlist.classListID;
        return CommonUtilities.deleteData(url);
    };

    static deletecontractStatus = function (contractStatus: any) {
        var url = 'contracts/contractStatus/delete/' + contractStatus.contractStatusId;
        return CommonUtilities.deleteData(url);
    };

    static deletestatusPayee = function (statusPayee: any) {
        var url = 'common/statusPayee/delete/' + statusPayee.payeeStatusID;
        return CommonUtilities.deleteData(url);
    };

    static deletestatusProduct = function (statusProduct: any) {
        var url = 'common/statusProduct/delete/' + statusProduct.productStatusID;
        return CommonUtilities.deleteData(url);
    };

    static deletestatusProductExt = function (statusProductExt: any) {
        var url = 'common/statusProductExt/delete/' + statusProductExt.productStatusExtID;
        return CommonUtilities.deleteData(url);
    };

    static deletestatusStatement = function (statusStatement: any) {
        var url = 'common/statusStatement/delete/' + statusStatement.productStatusExtID;
        return CommonUtilities.deleteData(url);
    };

    static deleteProjectStatus = function (projectStatus: any) {
        var url = 'contracts/projectStatus/delete/' + projectStatus.statusID;
        return CommonUtilities.deleteData(url);
    };


    /* **************** EXPORT ********************* */
    static SalesAnalysisExport(data: any) {
        const url = 'salesAnalysis/getSalesAnalysis/Export?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', data.type);
    };

    static formatCodeExport(data: any) {
        const url = 'release/getAllFormatCodeByParentGroup/Export?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', data.type);
    };

    static mechRateExport(data: any) {
        const url = 'contracts/mechRate/listExport?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', data.type);
    };

    static classlistExport(data: any) {
        const url = 'salesAnalysis/classlist/list/export?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', data.type);
    };

    static accountSubproviderExport(data: any) {
        const url = 'systemListing/accountSubprovider/ASPlist/Export?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', data.type);
    };
}